import { useCallback } from 'react'

import { useController, useFormContext } from 'react-hook-form'

import { TextField } from '@/components/ui/text-field'
import { DIALOG_TYPE } from '@/dialogs/constants.ts'
import { openDialog } from '@/models/dialogs.ts'

interface Props {
  name: string
  label?: string
  placeholder?: string
}

export const FormPickColor = ({ name, label, placeholder }: Props) => {
  const { control } = useFormContext()
  const {
    field,
    fieldState: { error },
  } = useController({ name, control })

  const handleOpenColorPickerDialog = useCallback(() => {
    openDialog({
      type: DIALOG_TYPE.COLOR_PICKER,
      onColorChange: field.onChange,
      oldColor: field.value,
    })
  }, [field.onChange, field.value])

  return (
    <div className="flex flex-1 flex-col gap-2">
      <label
        htmlFor={field.name}
        className="text-sm font-medium text-title"
      >
        {label}
      </label>
      <TextField
        {...field}
        className="h-10 text-title"
        placeholder={placeholder}
        type="text"
        prefix={
          <div
            className="h-6 w-6 flex-shrink-0 cursor-pointer rounded-full"
            style={{ backgroundColor: field.value }}
            onClick={handleOpenColorPickerDialog}
          />
        }
      />
      {error && <p className="text-xs text-danger-default">{error.message}</p>}
    </div>
  )
}
